module.exports = __webpack_public_path__ + "media/images/landingTeaser__bg--narrow-8bf61a4a4e7e264911f1cecba455b5fd.jpg";